module.exports = __webpack_public_path__ + "assets/img/PROCESS_PLUGIN.d7a65fa0.svg";